import { render, staticRenderFns } from "./GetHelpModal.vue?vue&type=template&id=2e510246&scoped=true&"
import script from "./GetHelpModal.vue?vue&type=script&lang=js&"
export * from "./GetHelpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e510246",
  null
  
)

export default component.exports